import Vue from 'vue'
import Loader from '@/modules/shared/components/global/Loader'
import Logo from '@/modules/shared/components/global/Logo'
import StarRating from '@/modules/shared/components/global/StarRating'
import StarRatingGrid from '@/modules/shared/components/global/StarRatingGrid'

export const loadComponents = () => {
  Vue.component('Loader', Loader)
  Vue.component('Logo', Logo)
  Vue.component('StarRating', StarRating)
  Vue.component('StarRatingGrid', StarRatingGrid)
}
